import { useLocation, useNavigate, useParams } from "react-router-dom";
import FormLoader from "../../Components/Common/FormLoader"
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { GetData, PostData, PostDataWithToken } from "../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import moment from "moment";
import { Spinner } from "reactstrap";

export default function CustomerReassignMeasurer() {
  const navigate = useNavigate();
  const location = useLocation();
  const [scheduleList, setScheduleList] = useState();
  const [EnquiryDetials, setEnquiryDetials] = useState({});
  const [SelectedValue, setSelectedValue] = useState("");
  const [scheduleMessage, setScheduleMessage] = useState("");
  const [AssignedPerson, setAssignedPerson] = useState({});
  const [AllTimeSlot, setAllTimeSlot] = useState([]);
  const [timeSlotValue, setTimeSlotValue] = useState();
  const [selectedInstaller, setSelectedInstaller] = useState({
    name: "",
    id: "",
  })
  console.log("loooo...", location);
  const [formStates, setFormStates] = useState({
    loader: true,
    showForm: false,
    buttonLoader: false,
  });


  const { url } = useParams();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const timeSlotChangeHandler = (e) => {
    setTimeSlotValue(e.target.value);
    // setCallApi2(true);
  };

  const watchAllFields = watch()

  useEffect(() => {
    GetData(`sales/get-enquiry/${url}`).then(
      (response) => {
        updateStateHandler("loader", false);
        if (response.status === true) {
          if (response?.data?.status == "measurer-assigned") {
            updateStateHandler("showForm", true);
          }
          setAssignedPerson({
            name: `${response?.data?.enquiryschedules?.[
              response?.data?.enquiryschedules?.length - 1
            ]?.user?.firstName} ${response?.data?.enquiryschedules?.[
              response?.data?.enquiryschedules?.length - 1
            ]?.user?.lastName}`,
            id: response?.data?.enquiryschedules?.[
              response?.data?.enquiryschedules?.length - 1
            ]?.user?.id
          })
          setEnquiryDetials(response?.data);
          const submitData = {
            categories: response?.data?.category,
            storeId: response?.data?.outlet?.id,
          }
          PostData(
            `superadmin/get-unassigned-user`,
            submitData
          ).then((response) => {
            if (response.status === true) {
              // setCallApi2(false);

              // setAllUnAssignedUser(response.data);
            } else {
              // setCallApi2(false);
            }
          });
        }
      }
    );
  }, [])

  const updateStateHandler = (key, value) => {
    setFormStates((prev) => ({
      ...prev,
      [key]: value
    }));
  }

  useEffect(() => {
    let userId;
    // if (EnquiryDetials.outlet?.email === "ffsl@fandf.in") {
    //   EnquiryDetials?.category?.includes("Wallpaper") ?
    //     userId = 41 : userId = 64
    // } else if (EnquiryDetials.outlet?.email === "smpc@fandf.in" ||
    //   EnquiryDetials.outlet?.email === "smldh@fandf.in"
    // ) {
    //   EnquiryDetials?.category?.includes("Wallpaper") ?
    //     userId = 126 : userId = 126
    // } else {
    //   EnquiryDetials?.category?.includes("Wallpaper") ?
    //     userId = 61 : userId = 58
    // }

    // EnquiryDetials.outlet?.email === "ffsl@fandf.in"|| ?
    //   userId = "22" : ""
    //   ;
    if (watchAllFields?.postpone_date) {
      GetData(`superAdmin/get-unassigned-timeslot/${AssignedPerson?.id}?date=${watchAllFields?.postpone_date}`).then((response) => {
        if (response.status == true) {
          setScheduleList(response?.data?.schedules);
        }
      })
    }
  }, [watchAllFields?.postpone_date])

  // const onSubmit = (data) => {

  //   const submitData = {
  //     schedulePersonId: AssignedPerson?.id,
  //     enquiryId: url,
  //     ScheduleId: timeSlotValue,
  //     date: data?.date,
  //   };
  //   console.log("submit dataaaa...", submitData);
  //   PostData(`auth/update-schedule`, submitData).then(response => {
  //     if (response.status === true) {
  //       toast.success("Measurer reassigned successfully");
  //       navigate("/thank-you")
  //     } else {
  //       toast.error(response.data.message);
  //     }
  //   })
  // }

  const CreateNewOutlet = (data) => {
    // let date;
    // date = isreassign === "measurement" ? { postpone_date: moment(data?.postpone_date).format("DD-MM-YYYY") } : { postponeDate: moment(data?.postponeDate).format("DD-MM-YYYY"), };
    updateStateHandler("buttonLoader", true);
    let arrayIndex = EnquiryDetials?.enquiryschedules?.length - 1;
    const val = {
      id: EnquiryDetials?.enquiryschedules?.[arrayIndex]?.id,
      status: "postponed",
      // scheduleId:"",
      remark: SelectedValue?.target?.value,
      postponeDate: moment(data?.postpone_date).format("YYYY-MM-DD"),
      scheduleId: timeSlotValue,
    };

    PostData("measurer/update-schedule", val).then((response) => {
      if (response.status === true) {
        updateStateHandler("buttonLoader", false);
        console.log("first", response.message);
        toast.success(response.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        navigate("/thank-you");
        // toggle();
      } else {
        toast.error(response.data.message, {
          position: "top-right",
        });
      }
    });
  };



  return (<div className="authincation h-100">
    <div className="container h-100vh">
      <div className="row justify-content-center h-100 align-items-center">
        <div className="col-xl-6">
          {formStates?.loader ? <FormLoader /> :
            <div className="authincation-content">
              <div className="row no-gutters">
                <div className="col-xl-12">
                  {!formStates?.showForm ?
                    <div class="card-header d-flex justify-content-center">
                      <h4>Access Denied !</h4>
                    </div> : <>
                      <div className="card-header">
                        <h4>Re-assign Measurer</h4>

                        {/* <span onClick={() => { navigate(-1) }} style={{ cursor: "pointer" }}><i className="fas fa-arrow-left" style={{ fontSize: "20px" }}></i></span> */}
                      </div>
                      <div className="container-fluid">
                        <div className="row flex-item-center">
                          <div className="col-xl-12">
                            <div class="basic-form">
                              <form onSubmit={handleSubmit(CreateNewOutlet)}>
                                <div className="mb-3 row align-items-center">
                                  <div className="col-lg-12 my-1">
                                    <label className="me-sm-2">
                                      Select Reason for Postponing Measurement
                                    </label>
                                    <select
                                      className="me-sm-2  form-control"
                                      onChange={(e) => {
                                        setSelectedValue(e);
                                      }}
                                      required
                                    >
                                      <option value={""} selected>Choose...</option>
                                      <option value={"No one is available at site"}>  No one is available at site</option>
                                      <option value={"Site is not Ready"}>
                                        Site is not Ready
                                      </option>
                                      {/* <option value={"Client is not sure about the product they have selected"}>
                                        not sure about the Selected product.
                                      </option> */}
                                      <option value={"Product selection pending"}>Product selection pending</option>
                                    </select>
                                  </div>
                                  <div>
                                    <label className="col-sm-12 col-form-label" htmlFor="fnf2">
                                      Date
                                    </label>
                                    <div className="col-sm-12">
                                      <input
                                        {...register("postpone_date", {
                                          required: "please enter date",
                                          // onChange: dateChangeHandler
                                        })}
                                        type="date"
                                        className="form-control"
                                        id="fnf2"
                                        placeholder="outlet Password"
                                        // readOnly="true"
                                        // value={lastId}
                                        min={moment().add(1, "days").format("YYYY-MM-DD")}
                                        required
                                      // minDate={new Date()}
                                      />
                                      <span className="text-danger">
                                        {errors.postpone_date && errors.postpone_date.message}
                                      </span>
                                    </div>
                                  </div>
                                  <div class="col-lg-12 my-1">
                                    <label class="me-sm-2">Select Time Slot For Your Measurement</label>
                                    <select class="me-sm-2  form-control"
                                      onChange={timeSlotChangeHandler}
                                      required
                                    >
                                      <option value="">Choose...</option>
                                      {scheduleList?.map((data) => <option value={data?.id}>{data?.start_time}-{data?.end_time}</option>)}
                                    </select>
                                  </div>
                                  <p className="text-danger">{scheduleMessage}</p>
                                </div>
                                <div className="form-buttons text-center mb-2">
                                  {/* <button onClick={() => toggle()} className="btn btn-secondary me-3">
                                    Cancel
                                  </button> */}

                                  <button
                                    className="btn btn-primary"
                                    disabled={formStates?.buttonLoader}
                                  >{formStates?.buttonLoader ?
                                    <Spinner />
                                    : "submit"}</button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>}

                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>)
}